import React, { useEffect } from "react";
import SignInForm from "./signInForm";

const SignIn = () => {

  return (
    <>
      <SignInForm />
    </>
  );
};

export default SignIn;
